import { motion } from "framer-motion";
import { ArrowUpRight, MousePointerClick } from "lucide-react";
import { Reveal } from "./Reveal";

const DEMO_URL = "https://firmtyres.lovable.app";

export const DemoSection = () => (
  <section id="demo" data-testid="demo-section" className="relative py-24 lg:py-28 bg-[#FAFAFA] border-y border-slate-100 overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(0,85,255,0.05),_transparent_60%)]" aria-hidden="true" />
    <div className="absolute inset-0 grid-bg opacity-60" aria-hidden="true" />
    <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Reveal>
        <p className="font-mono2 text-xs tracking-[0.25em] uppercase text-[#0055FF] mb-5 flex items-center justify-center gap-2">
          <MousePointerClick className="w-3.5 h-3.5" /> Interactive demo
        </p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter leading-[1.08] text-slate-900">
          See what we can build <span className="text-gradient-blue">for your business</span>
        </h2>
        <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed max-w-xl mx-auto">
          Explore our interactive website demo and see how your business could look online.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <motion.a
          href={DEMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="demo-cta-button"
          aria-label="Try our interactive website demo (opens in a new tab)"
          className="mt-10 inline-flex items-center gap-2.5 bg-[#0055FF] hover:bg-[#0044CC] text-white font-semibold text-base px-9 py-4 rounded-full transition-colors duration-200 glow-blue group"
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
        >
          Try Our Interactive Demo
          <ArrowUpRight className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </motion.a>
        <p className="mt-4 text-xs text-slate-400">Opens in a new tab — a live example of a WebStudios-built site</p>
      </Reveal>
    </div>
  </section>
);
